import * as React from 'react';
import { getCatalogTitle } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getItemSummaryLotNumber, getItemSummarySellerName } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveCatalogCurrentItemId } from '@/redux/modules/console';
import { openSendSellerMessageModal } from '@/redux/modules/modal';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import AuctioneerInfo from '@/components/AuctioneerInfo/AuctioneerInfo';

type Props = {
    catalogId: number;
    className?: string;
    sellerId: number;
};

const AuctioneerDetails = ({ catalogId, className, sellerId }: Props) => {
    const dispatch = useAppDispatch();
    const catalogTitle = useAppSelector((state) => getCatalogTitle(state, catalogId));
    const itemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    const lotNumber = useAppSelector((state) => getItemSummaryLotNumber(state, itemId));
    const sellerName = useAppSelector((state) => getItemSummarySellerName(state, itemId));

    const showSendSellerMessageModal = React.useCallback(() => {
        const messageDetails = {
            catalogId,
            itemId,
            lotNumber,
            title: catalogTitle,
        };

        dispatch(openSendSellerMessageModal(messageDetails, sellerId, sellerName, catalogTitle));
    }, [dispatch, catalogId, catalogTitle, itemId, lotNumber, sellerId, sellerName]);

    return (
        <AuctioneerInfo
            className={className}
            openOnBlank
            sellerId={sellerId}
            showSendSellerMessageModal={showSendSellerMessageModal}
        />
    );
};

export default AuctioneerDetails;
